export default {
  invoices: [],
  invoicesFilter: [],
  invoiceTypes: [],
  invoiceStatuses: [],
  invoiceMassStatuses: [],
  currentInvoice: {},
  payrolls: [],
  payrollsFilter: [],
  payrollStatuses: [],
  payrollMassStatuses: [],
  currentPayroll: {},
  expenses: [],
  expensesFilter: {},
  amountMassStatuses: [],
  expense: {},
  invoicesErrors: [],
  accountParams: [],
  ereporterChip: null
};
